import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { numToPrice, priceSum } from '../../../utils/functions';
import Moment from 'moment-jalaali';
import { useTranslation } from 'react-i18next';

export default function ReportExpert({ report }) {

    const { user } = useSelector((store) => store);
    //
    const { t } = useTranslation();
    const [ finalResult, setFinalResult] = useState({
        accessories:0,
        wages:0,
        extras:0,
        deducts:0,
        sum:0
    })
    useEffect (()=>{
        const arcAndCom = [report.archives,report.complements]
        let accessories = 0 
        let wages = 0
        let extras = 0
        let deducts = 0
        arcAndCom.map(items=>{
        ////adding archives & complements
        items.length && items.map(item=>{
            if(!!JSON.parse(item.accessories || "[]").length){
                accessories = parseInt(accessories + priceSum(item.accessories));
            }  
            if(!!JSON.parse(item.wages || "[]").length){
                wages = parseInt(wages + priceSum(item.wages));
            }
            if(!!JSON.parse(item.extras || "[]").length){
                extras = parseInt(extras + priceSum(item.extras));
            }
            if(!!JSON.parse(item.deducts || "[]").length){
                deducts = parseInt(deducts + priceSum(item.deduct));
            }  
            
        })
    })
        ////adding archives & complements & main report
        setFinalResult({
            accessories:parseInt(accessories + priceSum(report.accessories)),
            wages:parseInt(wages + priceSum(report.wages)),
            extra:parseInt(extras + priceSum(report.extras)),
            deducts:parseInt(deducts + priceSum(report.deducts)),
            sum:accessories+wages+extras-deducts +priceSum(report.accessories)+priceSum(report.wages)+priceSum(report.extras)-priceSum(report.deducts)
        })
    },[])

    return (
      (user.type === "expert" || [1, 2, 5].includes(report.status)) && (
        <>
          <div className="box">
              <div className="box-header">
                    <p className="title">{t('Report expert')}</p>
              </div>
            {!!JSON.parse(report.accessories || "[]").length && (
              <div className="box inner-box">
                <p className="title"> {t('Accessories list')}</p>
                {JSON.parse(report.accessories).map((accessory, index) => (
                  <div className="textParent" key={index}>
                    <div className="text">{index+1}. {accessory.name}:</div>
                    <div className="text text-left">
                      {accessory.price
                        ? `${numToPrice(accessory.price)} ${t('rial')}`
                        : t('Uknown')}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {!!JSON.parse(report.wages || "[]").length && (
              <div className="box inner-box">
                <p className="title"> {t('Wage list')}</p>
                {JSON.parse(report.wages).map((wage, index) => (
                  <div className="textParent" key={index}>
                    <div className="text">{index+1}. {wage.name}:</div>
                    <div className="text text-left">
                      {wage.price
                        ? `${numToPrice(wage.price)} ${t('rial')}`
                        : t('Uknown')}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {!!JSON.parse(report.extras || "[]").length && (
              <div className="box inner-box">
                <p className="title"> {t('Extra list')}</p>
                {JSON.parse(report.extras).map((extra, index) => (
                  <div className="textParent" key={index}>
                    <div className="text">{index+1}. {extra.name}:</div>
                    <div className="text text-left">
                      {extra.price
                        ? `${numToPrice(extra.price)} ${t('rial')} `
                        : t('Uknown')}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {!!JSON.parse(report.deducts || "[]").length && (
              <div className="box inner-box">
                <p className="title"> {t('Deduct list')}</p>
                {JSON.parse(report.deducts).map((deduct, index) => (
                  <div className="textParent" key={index}>
                    <div className="text">{index+1}. {deduct.name}:</div>
                    <div className="text text-left">
                      {deduct.price
                        ? `${numToPrice(deduct.price)} ${t('rial')} `
                        : t('Uknown')}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* {new} */}
          {report.archives.length > 0 && report.archives.map((item) => (
              <div className="box" key={item.id}>
                <div className="box-header">
                    <p className="title">{t('Archives list')}-<small>{` ${Moment(item.created_at).format("jYYYY/jM/jD")} `}</small></p>
                </div>
                {!!JSON.parse(item.accessories || "[]").length && (
                  <div className="box inner-box">
                    <p className="title"> {t('Accessories list')}</p>
                    {JSON.parse(item.accessories).map((accessory, index) => (
                      <div className="textParent" key={index}>
                        <div className="text">{index+1}. {accessory.name}:</div>
                        <div className="text text-left">
                          {accessory.price
                            ? `${numToPrice(accessory.price)} ${t('rial')} `
                            : t('Uknown')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {!!JSON.parse(item.wages || "[]").length && (
                  <div className="box inner-box">
                    <p className="title"> {t('Wage list')}</p>
                    {JSON.parse(item.wages).map((wage, index) => (
                      <div className="textParent" key={index}>
                        <div className="text">{index+1}. {wage.name}:</div>
                        <div className="text text-left">
                          {wage.price
                            ? `${numToPrice(wage.price)} ${t('rial')} `
                            : t('Uknown')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {!!JSON.parse(item.extras || "[]").length && (
                  <div className="box inner-box">
                    <p className="title"> {t('Extra list')}</p>
                    {JSON.parse(item.extras).map((extra, index) => (
                      <div className="textParent" key={index}>
                        <div className="text">{index+1}. {extra.name}:</div>
                        <div className="text text-left">
                          {extra.price
                            ? `${numToPrice(extra.price)} ${t('rial')} `
                            : t('Uknown')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {!!JSON.parse(item.deducts || "[]").length && (
                  <div className="box inner-box">
                    <p className="title"> {t('Deduct list')}</p>
                    {JSON.parse(item.deducts).map((deduct, index) => (
                      <div className="textParent" key={index}>
                        <div className="text">{index+1}. {deduct.name}:</div>
                        <div className="text text-left">
                          {deduct.price
                            ? `${numToPrice(deduct.price)} ${t('rial')} `
                            : t('Uknown')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          {report.complements.length > 0 && report.complements.map((item) => (
            <div className="box" key={item.id}>
              <div className="box-header">
                <p className="title">{t('Complements')}-<small>{` ${Moment(item.created_at).format("jYYYY/jM/jD")} `}</small></p>
              </div>
              {!!JSON.parse(item.accessories || "[]").length && (
                <div className="box inner-box">
                  <p className="title"> {t('Accessories list')}</p>
                  {JSON.parse(item.accessories).map((accessory, index) => (
                    <div className="textParent" key={index}>
                      <div className="text">{index+1}. {accessory.name}:</div>
                      <div className="text text-left">
                        {accessory.price
                          ? `${numToPrice(accessory.price)} ${t('rial')} `
                          : t('Uknown')}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {!!JSON.parse(item.wages || "[]").length && (
                <div className="box inner-box">
                  <p className="title"> {t('Wage list')}</p>
                  {JSON.parse(item.wages).map((wage, index) => (
                    <div className="textParent" key={index}>
                      <div className="text">{index+1}. {wage.name}:</div>
                      <div className="text text-left">
                        {wage.price
                          ? `${numToPrice(wage.price)} ${t('rial')} `
                          : t('Uknown')}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {!!JSON.parse(item.extras || "[]").length && (
                <div className="box inner-box">
                  <p className="title"> {t('Extra list')}</p>
                  {JSON.parse(item.extras).map((extra, index) => (
                    <div className="textParent" key={index}>
                      <div className="text">{index+1}. {extra.name}:</div>
                      <div className="text text-left">
                        {extra.price
                          ? `${numToPrice(extra.price)} ${t('rial')} `
                          : t('Uknown')}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {!!JSON.parse(item.deducts || "[]").length && (
                <div className="box inner-box">
                  <p className="title"> {t('Deduct list')}</p>
                  {JSON.parse(item.deducts).map((deduct, index) => (
                    <div className="textParent" key={index}>
                      <div className="text">{index+1}. {deduct.name}:</div>
                      <div className="text text-left">
                        {deduct.price
                          ? `${numToPrice(deduct.price)} ${t('rial')} `
                          : t('Uknown')}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="box">
            <p className="title border-bottom pb5"> {t('Total')} </p>
            <div className="textParent">
              <div className="text">{t('Total accessories')}:</div>
              <div className="text text-left">
                {/* {numToPrice(priceSum(report.accessories))} ریال */}
                {numToPrice(finalResult.accessories)} {t('rial')}
              </div>
            </div>
            <div className="textParent">
              <div className="text">{t('Total wages')}:</div>
              <div className="text text-left">
                {" "}
                {/* {numToPrice(priceSum(report.wages))} ریال */}
                {numToPrice(finalResult.wages)} {t('rial')}
              </div>
            </div>
            <div className="textParent">
              <div className="text">{t('Total extra')}:</div>
              <div className="text text-left">
                {" "}
                {/* {numToPrice(priceSum(report.extras))} ریال */}
                {numToPrice(finalResult.extras)} {t('rial')}
              </div>
            </div>
            <div className="textParent">
              <div className="text">{t('Total deduct')}:</div>
              <div className="text text-left">
                {" "}
                {/* {numToPrice(priceSum(report.deducts))} ریال */}
                {numToPrice(finalResult.deducts)} {t('rial')}
              </div>
            </div>
            <div className="textParent border-top p5">
              <div className="text">{t('Final total')}:</div>
              <div className="text text-left">
                {" "}
                {numToPrice(finalResult.sum)} {t('rial')}
              </div>
            </div>
          </div>
        </>
      )
    );
}
